module.exports = __webpack_public_path__ + "img/volkswagen.83abfbf5.jpg";